export const HUE_MAX = 360;
export const ALPHA_MAX = 100;
